










































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IWorkflowForSelection } from '@/api/types/response.types'
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'EntityWorkflowSelector',

  props: {
    workflows: {
      type: Array as () => IWorkflowForSelection[],
      required: true,
    },
    value: {
      type: Number,
      default: null,
    },
    defaultValue: {
      type: Number,
      default: null,
    },
    fixedHeight: {
      type: Boolean,
      default: true,
    },
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
  },
  data() {
    return {
      EEntities,
    }
  },
  computed: {
    internalValue: {
      get(): Number {
        return this.value
      },
      set(value: Number) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    defaultValue: {
      immediate: true,
      handler(val) {
        if (val !== null) {
          this.internalValue = val
          const a = this.$refs[this.getWorkflowRef(val)]
          this.$nextTick(() => {
            // @ts-ignore
            a[0].scrollIntoView({ block: 'start', inline: 'nearest' })
          })
        }
      },
    },
  },

  methods: {
    getWorkflowRef(workflowID: number): string {
      return `workflow-${workflowID}`
    },
    isSelected(workflow: IWorkflowForSelection): boolean {
      return this.internalValue === workflow.id
    },
    selectWorkflow(workflow: IWorkflowForSelection) {
      this.internalValue = workflow.id
    },
    hasJobs(workflow: IWorkflowForSelection): boolean {
      return workflow.listJobs.length > 0
    },
  },
})
